import React from 'react';
import {
    ContentLoader,
    formatNumber,
    MobileCardRowsProps,
} from '@dev/ee-components';
import { truncate } from 'lodash-es';
import { CampaignsInterface } from '@/store/campaigns/types';
import { StatusBadgeComponent } from '@/components/Campaigns/CampaignsList/components/StatusBadge';

export const useMobileTableRows = (campaigns: CampaignsInterface): MobileCardRowsProps[] => {
    if (campaigns?.loading) {
        return [...new Array(3)].map(() => ({
            tableTitle: <ContentLoader mode="row" />,
            status: <ContentLoader count={1} mode="row" />,
            opened: <ContentLoader count={1} mode="row" />,
            clicked: <ContentLoader count={1} mode="row" />
        }));
    }

    return campaigns?.collection?.map((campaign): MobileCardRowsProps => ({
        tableTitle: truncate(campaign.Name, { length: 35, omission: '...' }),
        status: <StatusBadgeComponent status={campaign.Status} index={campaign.Name} />,
        opened: <>{formatNumber(campaign.Stats.Opened)}</>,
        clicked: <>{formatNumber(campaign.Stats.Clicked)}</>,
        returnOnItemClick: campaign as unknown as string | JSX.Element
    }));
};
